// Desc: This file contains utility functions that are used throughout the application
function Utilities_JS() {

    this.StringToDate = (date, format) => {
        if (date == "") return '';
        var formatItems = format.split(/[\/: ]+/);
        var dateItems = date.split(/[\/: ]+/);
        var monthIndex = formatItems.indexOf("MM");
        var dayIndex = formatItems.indexOf("dd");
        var yearIndex = formatItems.indexOf("yyyy");
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        var hourIndex = formatItems.indexOf("HH");
        var minuteIndex = formatItems.indexOf("mm");
        var secondIndex = formatItems.indexOf("ss");

        var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex], dateItems[hourIndex], dateItems[minuteIndex], dateItems[secondIndex]);
        return formatedDate;
    }

    this.JsonParseBigInt = (jsonString) => {
        if (typeof jsonString !== 'string') return jsonString;

        const regex = /([^\\]"\s{0,}:\s{0,})([0-9]{17,})(\s{0,}[,}])/g;
        const serializedData = jsonString.replace(regex, '$1"$2"$3');

        try {
            return JSON.parse(serializedData);
        }
        catch (e) {

            console.log("parseJsonBigint Exception", e);
            console.log("serializedData", serializedData);
        }
    }


    this.ConvertInt64ToDateTimeString = (lvalue, isFormatHaveTime, timeZone) => {
        try {
            if (lvalue <= 0)
                return '';

            let year = Math.floor(lvalue / 10000000000);
            let month = Math.floor((lvalue % 10000000000) / 100000000) - 1;
            let day = Math.floor((lvalue % 100000000) / 1000000);
            let hour = Math.floor((lvalue % 1000000) / 10000);
            let minute = Math.floor((lvalue % 10000) / 100);
            let second = Math.floor(lvalue % 100);
            let dtValue = new Date(year, month, day, hour, minute, second);

            if (isFormatHaveTime)
                return this.FormatDateTime(dtValue, timeZone);
            else
                return this.FormatDateTime_NoTime(dtValue, timeZone);
        }
        catch {
            return '';
        }
    }

    this.ConvertInt64ToDateTime = (lvalue) => {
        try {
            if (lvalue <= 0)
                return '';

            let year = Math.floor(lvalue / 10000000000);
            let month = Math.floor((lvalue % 10000000000) / 100000000) - 1;
            let day = Math.floor((lvalue % 100000000) / 1000000);
            let hour = Math.floor((lvalue % 1000000) / 10000);
            let minute = Math.floor((lvalue % 10000) / 100);
            let second = Math.floor(lvalue % 100);
            let dtValue = new Date(year, month, day, hour, minute, second);

            return dtValue;
        }
        catch {
            return '';
        }
    }

    this.FormatDateTime = (date, timeZone) => {
        let dd = date.getDate();
        let mm = date.getMonth() + 1; //January is 0!
        let yyyy = date.getFullYear();
        let hh = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();

        if (dd < 10) {
            dd = "0" + dd;
        }

        if (mm < 10) {
            mm = "0" + mm;
        }

        if (hh < 10) {
            hh = "0" + hh;
        }

        if (min < 10) {
            min = "0" + min;
        }

        if (sec < 10) {
            sec = "0" + sec;
        }

        if (timeZone)
            return mm + "/" + dd + "/" + yyyy + " " + hh + ":" + min + ":" + sec + " (" + this.GetTimeZoneName(timeZone) + ")";
        else
            return mm + "/" + dd + "/" + yyyy + " " + hh + ":" + min + ":" + sec;
    }

    this.ConvertTicksToDateTime = (ticks) => {
        // the number of .net ticks at the unix epoch
        const epochTicks = 621355968000000000;

        // there are 10000 .net ticks per millisecond
        let ticksPerMillisecond = 10000;
        // calculate the total number of .net ticks for your date
        let milliseconds = (ticks - epochTicks) / ticksPerMillisecond;
        let date = new Date(milliseconds);
        return date;
    }

    this.GetTimeZoneName = (timeZone) => {
        // format timezone is GMT (+/-)HH:MM
        if (timeZone == null || timeZone == '') return '';

        let timeZoneName = timeZone;

        if (timeZoneName.indexOf('GMT') >= 0) {
            timeZoneName = timeZoneName.replace('GMT', '');

            let checkIsDaylightSavingTime = new Date().isDstObserved();

            // calculate hour
            let hour = parseInt(timeZoneName.split(':')[0]);
            let minute = parseInt(timeZoneName.split(':')[1]);

            let offset = hour * 60 + minute;

            if (checkIsDaylightSavingTime) {
                offset += 60;
            }

            switch (offset) {
                case 0:
                    timeZoneName = 'UTC';
                    break;
                case -5 * 60:
                    timeZoneName = 'EST';
                    break;
                case -6 * 60:
                    timeZoneName = 'CST';
                    break;
                case -7 * 60:
                    timeZoneName = 'MST';
                    break;
                case -8 * 60:
                    timeZoneName = 'PST';
                    break;
                case -9 * 60:
                    timeZoneName = 'AKST';
                    break;
                case -10 * 60:
                    timeZoneName = 'HST';
                    break;
                default:
                    timeZoneName = 'GMT' + timeZoneName;
            }
        }

        return timeZoneName;
    }

    this.FormatDateTime_NoTime = (date, timeZone) => {
        let dd = date.getDate();
        let mm = date.getMonth() + 1; //January is 0!
        let yyyy = date.getFullYear();
        let hh = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();

        if (dd < 10) {
            dd = "0" + dd;
        }

        if (mm < 10) {
            mm = "0" + mm;
        }

        if (hh < 10) {
            hh = "0" + hh;
        }

        if (min < 10) {
            min = "0" + min;
        }

        if (sec < 10) {
            sec = "0" + sec;
        }

        if (timeZone)
            return mm + "/" + dd + "/" + yyyy + " (" + this.GetTimeZoneName(timeZone) + ")";
        else
            return mm + "/" + dd + "/" + yyyy;
    }


    this.GetParamByQueryKey = (key) => {
        let url = window.location.href.toLowerCase();
        let query = url.split("?")[1];

        if (!query) { return ''; }

        let params = query.split("&");
        let param = params.find((param) => {
            return param.split("=")[0] === key.toLowerCase();
        });

        if (!param) { return ''; }

        return param.split("=")[1];
    }

    this.ConvertDateTimeToTicks = (dateTime) => {

        // the number of .net ticks at the unix epoch
        const epochTicks = 621355968000000000;

        // there are 10000 .net ticks per millisecond
        let ticksPerMillisecond = 10000;

        // calculate the total number of .net ticks for your date
        let ticks = epochTicks + (dateTime.getTime() * ticksPerMillisecond);

        return ticks;
    }

    this.GetUtcDate = (localDate) => {
        let date = new Date();
        const timezoneOffset = date.getTimezoneOffset();

        // convert localDate to milliseconds and adjust for timezone offset
        const utcTime = localDate.getTime() + (timezoneOffset * 60000);

        // create a new Date object with the adjusted time
        const utcDate = new Date(utcTime);

        return utcDate;
    }

    this.ValidationEmail = (email) => {
        let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    }

    this.GetTimeZoneStringByOffset = (offset) => {
        let timeZoneName = '';

        let hour = Math.floor(offset / 60);
        if (hour < 10) {
            hour = '0' + hour;
        }

        let minute = offset % 60;

        if (minute < 10) {
            minute = '0' + minute;
        }

        hour = Math.abs(hour);

        switch (true) {
            case offset == 0:
                timeZoneName = '(GMT)';
                break;
            case offset < 0:
                timeZoneName = `(GMT +${hour}:${minute})`;
                break;
            case offset > 0:
                timeZoneName = `(GMT -${hour}:${minute})`;
                break;
            default:
                timeZoneName = `(GMT)`;
        }

        return timeZoneName;
    }

    this.GetDateTimeOfIncident = (strDateTimeIncident) => {
        if (!strDateTimeIncident || strDateTimeIncident === '') return '';

        // format is MM/dd/yyyy HH:mm:ss (GMT)

        let dateTimeParts = strDateTimeIncident.split(' ');
        if (dateTimeParts.length < 2) return '';
        let datePart = dateTimeParts[0];
        let timePart = dateTimeParts[1];
        let dateParts = datePart.split('/');
        if (dateParts.length !== 3) return '';
        let month = parseInt(dateParts[0], 10) - 1; // JavaScript months are 0-11
        let day = parseInt(dateParts[1], 10);
        let year = parseInt(dateParts[2], 10);
        let timeParts = timePart.split(':');
        if (timeParts.length !== 3) return '';
        let hours = parseInt(timeParts[0], 10);
        let minutes = parseInt(timeParts[1], 10);
        let seconds = parseInt(timeParts[2], 10);
        let dateTime = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

        return dateTime;
    }

    this.FormatNumber = (number, locale = 'en-US') => {
        return new Intl.NumberFormat(locale).format(number);
    }
}

const Utilities = new Utilities_JS();
export default Utilities;